const getParentOrCanonicalRoute = (parents, product) => {
    if (parents && parents.length > 0) {
        return parents;
    }
    else if (product && product.primaryRoute) {
        return product.primaryRoute.parents;
    }
    else {
        return null;
    }
};
export default getParentOrCanonicalRoute;
//# sourceMappingURL=getParentsOrCanonicalRoute.js.map